import React, {useEffect, useState} from 'react';
import {injectIntl} from 'react-intl';
import axios from 'axios';
import Button from '@FormComponents/Button';
import NoticeInPage from '@Components/NoticeInPage';
import ConnectAndRequestEmployeeForm from '@Components/ConnectAndRequestEmployeeForm';
import {pushFindEmployeesFormSubmitEvent} from 'dataLayerHelper';
import {useCookies} from 'react-cookie';

const ConnectWithUsForm = ({intl, queryParams, match}) => {
  const [state, setState] = useState({});
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [cookies] = useCookies(['hubspotutk', '_ga']);

  useEffect(() => {
    const isZip = /^[0-9]{5}$/.test(queryParams.location);
    setState({
      candidate_location_browse_talent: isZip ? '' : (queryParams.location || ''),
      zip: isZip ? queryParams.location : '',
      candidate_search_criteria: queryParams.keyword,
      url_parameter: window.location.href,
      form_submission_id: cookies._ga ? cookies._ga : '',
    });
  }, []);

  const onChange = (event) => {
    const name = event.target.name;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    setState((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const onSubmit = () => {
    setLoading(true);
    axios.post(`${process.env.REACT_APP_API_PREFIX}/get-callback`, {
      callback: '@Callbacks/requestEmployee',
      currentRoute: {...match, ...{routeName: 'connect-with-us'}},
      data: state,
    }).then(async (response) => {
      setErrors({});
      let hsObjectId = '';
      await axios.post(`${process.env.REACT_APP_API_PREFIX}/get-callback`, {
        callback: '@Callbacks/getHubspotContact',
        currentRoute: {},
        data: state.email,
      }).then((response) => {
        if (response.data) {
          hsObjectId = response.data.data.vid;
        }
      }).catch((e) => {});
      pushFindEmployeesFormSubmitEvent('find employee - generic', {
        formType: 'find employee',
        formName: 'connect with us',
        formGuid: cookies.hubspotutk,
        clientFormSubmission: 1,
        hs_contact_id: hsObjectId,
        submissionId: state.form_submission_id,
      });
      // Set timeout before redirect to allow gtm events to execute.
      setTimeout(() => {
        setLoading(false);
        window.location.href = '/find-employees/confirmation';
      }, 200);
    }).catch((err) => {
      if (err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      } else {
        setErrors({generalError: 'RequestThisEmployee.Form.GeneralError'});
      }
      setLoading(false);
    });
  };

  return (
    <>
      <div className="block block--request bg-brand--white">
        <div className="py-l l:py-xl l:flex wrapper">
          <div className="block__header">
            <h2 className="block__title">{intl.formatMessage({id: 'ConnectWithUsForm.Form.Title'})}</h2>
            <div className="mt-s">{intl.formatMessage({id: 'ConnectWithUsForm.Form.SubTitle'})}</div>
          </div>
          <div className="block__content">
            {errors.generalError && <NoticeInPage type="negative" content={errors.generalError} extraClasses="mb-s" />}
            <ConnectAndRequestEmployeeForm
              type='connectWithUs'
              state={state}
              setState={setState}
              errors={errors}
              setErrors={setErrors}
              onChange={onChange}
            />
            <div className="form-group pt-m">
              <Button loading={loading} className="button button--m button--filled" onClick={onSubmit}>
                {intl.formatMessage({id: 'RequestThisEmployee.Form.SubmitButton.Label'})}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default injectIntl(ConnectWithUsForm);
